import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { NgPagination } from './components/paginator/ng-pagination/ng-pagination.component';
import { FormsModule } from '@angular/forms';
import { SortIconComponent } from './components/sort-icon/sort-icon.component';
import { InlineSVGModule } from 'ng-inline-svg';
import { TranslateModule } from "@ngx-translate/core";
import { CpfCnpjValidatorDirective } from '../../core/directives/cpf-cnpj-validator.directive';
@NgModule({
  declarations: [PaginatorComponent, NgPagination, SortIconComponent, CpfCnpjValidatorDirective],
  imports: [CommonModule, FormsModule, InlineSVGModule, TranslateModule.forChild()  ],
  exports: [PaginatorComponent, NgPagination, SortIconComponent, CpfCnpjValidatorDirective],
})
export class CRUDTableModule { }
